/*
 * Author: Dw
 * File Created: Tuesday, 24-08-06 11:12 am
 * Last Modified: Wednesday, 24-11-27 03:57 pm, by Harper Yan
 */

import { useTranslation } from 'next-i18next';
import { useMediaQuery, useTheme } from '@mui/material';
import useLanguage from '@/hooks/useLanguage';
export interface HeaderMenuItem {
  title: string;
  href: string;
  target: string;
  highlight?: boolean;
  show?: boolean;
}
const useHeaderConfig = (vip = false) => {
  const theme = useTheme();
  const {
    t
  } = useTranslation('common');
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const {
    curLocale
  } = useLanguage();
  const HeaderMenu: HeaderMenuItem[] = [{
    title: t('header.luminaries'),
    href: '/luminaries',
    target: '_self',
    highlight: true,
    show: false
  }, {
    title: t('header.events'),
    href: '/events',
    target: '_self',
    show: false
  }, {
    title: t('header.media'),
    href: '/media',
    target: '_self',
    show: false
  }, {
    title: t('header.blog'),
    href: '/blog',
    target: '_self',
    show: false
  }, {
    title: t('header.about-us'),
    href: '/about-us',
    target: '',
    show: false
  }, {
    title: t('header.telegram-bot'),
    href: 'https://t.me/TheDeHelpBot',
    target: '_blank',
    show: !vip
  }, {
    title: t('header.faq'),
    href: curLocale === 'en' ? 'https://help.thedecard.com/v/en/decard' : 'https://help.thedecard.com/decard',
    target: '_blank',
    show: !vip
  }];
  return {
    configs: HeaderMenu.filter(item => item.show),
    isMobile: isXs
  };
};
export default useHeaderConfig;